"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/design-system/utils/cn";
import DetailsBox from "~/components/job-page/jobadtemplate/details-box-eon";
import { LocationDisplay } from "~/components/ui/location-display-eon";
import { PrintDropdown } from "~/components/ui/print-dropdown-eon";
import ShareDropdown from "~/components/ui/share-dropdown-eon";
import { WatchJobButton } from "~/components/ui/watch-job-button-eon";
import { toSimilarJob } from "~/lib/utils/to-similar-job";
import { useLanguage } from "~/translations/loader/use-language";
import type { JobadComponentProps } from "~/types/job";
export default function JobAdTemplateMjp(t0) {
  const $ = _c(60);
  const {
    job
  } = t0;
  const t = useLanguage();
  const data = job.data;
  let t1;
  if ($[0] !== data.title) {
    t1 = <h2 className="mb-4 font-bold text-4xl text-primary md:text-5xl">{data.title}</h2>;
    $[0] = data.title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !data.locations || data.locations.length === 1 ? `${t.jobad_locationDisplay_single}: ` : `${t.jobad_locationDisplay_multi}: `;
  let t3;
  if ($[2] !== t2) {
    t3 = <span className="font-medium" data-source="lc">{t2}</span>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== job) {
    t4 = <LocationDisplay job={job} showAll={true} />;
    $[4] = job;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <div className="text-lg">{t3}{t4}</div>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = cn("mt-6 grid-cols-2 gap-x-24 text-foreground text-xl md:text-lg lg:grid xl:gap-x-32", "[&_p+p]:mt-4", "[&_p:not(li>p)]:mb-4", "[&_h3]:mt-6 [&_h3]:font-bold", "overflow-wrap-break-word");
    t7 = {
      gridTemplateColumns: "minmax(0, 1fr) 400px"
    };
    $[9] = t6;
    $[10] = t7;
  } else {
    t6 = $[9];
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t.jobad_description_HL) {
    t8 = <h3 className="mt-6 font-bold text-xl" data-source="lc">{t.jobad_description_HL}</h3>;
    $[11] = t.jobad_description_HL;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== job.content.task || $[14] !== job.content.taskHL) {
    t9 = job.content.task && <div className="mt-6">{job.content.taskHL && <h3 className="font-bold" data-source="job">{job.content.taskHL}</h3>}<div dangerouslySetInnerHTML={{
        __html: job.content.task
      }} data-source="job" /></div>;
    $[13] = job.content.task;
    $[14] = job.content.taskHL;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== job.content.profile || $[17] !== job.content.profileHL) {
    t10 = job.content.profile && <div className="mt-6">{job.content.profileHL && <h3 className="font-bold" data-source="job">{job.content.profileHL}</h3>}<div dangerouslySetInnerHTML={{
        __html: job.content.profile
      }} data-source="job" /></div>;
    $[16] = job.content.profile;
    $[17] = job.content.profileHL;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== job.content.offer || $[20] !== job.content.offerHL) {
    t11 = job.content.offer && <div className="mt-6">{job.content.offerHL && <h3 className="font-bold" data-source="job">{job.content.offerHL}</h3>}<div dangerouslySetInnerHTML={{
        __html: job.content.offer
      }} data-source="job" /></div>;
    $[19] = job.content.offer;
    $[20] = job.content.offerHL;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t.jobad_inclusionHL) {
    t12 = <p className="mt-12 font-bold" data-source="lc">{t.jobad_inclusionHL}</p>;
    $[22] = t.jobad_inclusionHL;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t.jobad_inclusion_text) {
    t13 = <p data-source="lc">{t.jobad_inclusion_text}</p>;
    $[24] = t.jobad_inclusion_text;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t.jobad_inclusion_textSub) {
    t14 = <p data-source="lc">{t.jobad_inclusion_textSub}</p>;
    $[26] = t.jobad_inclusion_textSub;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t12 || $[29] !== t13 || $[30] !== t14) {
    t15 = <div>{t12}{t13}{t14}</div>;
    $[28] = t12;
    $[29] = t13;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t10 || $[33] !== t11 || $[34] !== t15 || $[35] !== t8 || $[36] !== t9) {
    t16 = <div>{t8}{t9}{t10}{t11}{t15}</div>;
    $[32] = t10;
    $[33] = t11;
    $[34] = t15;
    $[35] = t8;
    $[36] = t9;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== job) {
    t17 = <DetailsBox job={job} />;
    $[38] = job;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== job.data) {
    t18 = toSimilarJob(job.data);
    $[40] = job.data;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== t18) {
    t19 = <WatchJobButton jobData={t18} variant="purple" />;
    $[42] = t18;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== job) {
    t20 = <ShareDropdown job={job} variant="purple" />;
    $[44] = job;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <PrintDropdown asButton={true} variant="purple" />;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== t19 || $[48] !== t20) {
    t22 = <section className="mt-4 grid h-10 grid-flow-col grid-cols-3 gap-4 text-white [&_button]:rounded-[var(--filtermenu-radius)]">{t19}{t20}{t21}</section>;
    $[47] = t19;
    $[48] = t20;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  let t23;
  if ($[50] !== t17 || $[51] !== t22) {
    t23 = <div className="flex flex-col">{t17}{t22}</div>;
    $[50] = t17;
    $[51] = t22;
    $[52] = t23;
  } else {
    t23 = $[52];
  }
  let t24;
  if ($[53] !== t16 || $[54] !== t23) {
    t24 = <div className={t6} style={t7}>{t16}{t23}</div>;
    $[53] = t16;
    $[54] = t23;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  let t25;
  if ($[56] !== t1 || $[57] !== t24 || $[58] !== t5) {
    t25 = <section className="grid w-full justify-center py-10 md:py-20 print:hidden" id="job" tabIndex={-1}><div className="mx-6 max-w-screen-xl md:mx-10">{t1}{t5}{t24}</div></section>;
    $[56] = t1;
    $[57] = t24;
    $[58] = t5;
    $[59] = t25;
  } else {
    t25 = $[59];
  }
  return t25;
}